__turbopack_context__.v({
  "item": "ScrollableItem-module-scss-module__rgtRbG__item",
});
